module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07471_logo_200x200.8fe9d3b0.png";